import { Link } from "react-router-dom";
import { SuccesSVG } from "../../assets";

function SuccessPage() {
  return (
    <div className="w-full h-full flex items-center flex-col  justify-center">
      <div
        style={{
          height: 332,
          width: 332,
        }}
        className="rounded-lg p-6 mt-8 flex flex-col items-center justify-center"
      >
        <img className="cursor-pointer" src={SuccesSVG} alt="SuccesSVG-icon" />
      </div>
      <div className="mt-8 text-xl font-semibold">
        Password Reset Successfully
      </div>
      <div className="text-gray-500">
        Your password has been successfully changed.{" "}
      </div>
      <Link className="mt-2 text-[blue] underline" to={"/login"}>
        Back To Login
      </Link>
    </div>
  );
}

export default SuccessPage;
